import { useBlocker } from 'react-router-dom';
import { useEffect } from 'react';

const useBlockUnsavedChanges = isDirty => {
    const blocker = useBlocker(isDirty);

    useEffect(() => {
        if (blocker.state === 'blocked') {
            if (
                confirm(
                    'You have unsaved changes, do you want to discard them?',
                )
            ) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker.state]);

    return blocker;
};

export default useBlockUnsavedChanges;
